module.exports = __webpack_public_path__ + "img/自动语音警告系统V1.0.80a77896.jpg";